
<footer class="body-font">
    <div
      class="
        container
        px-5
        py-24
        mx-auto
        flex
        md:items-center
        lg:items-start
        md:flex-row md:flex-nowrap
        flex-wrap flex-col
      "
    >
      <div
        class="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left"
      >
        <a
          href=""
          class="
            flex
            title-font
            font-medium
            items-center
            md:justify-start
            justify-center
            text-white
          "
        >
          <i class="fas fa-cubes fa-lg text-white"></i>
          <span class="ml-3 text-xl">FyreHost</span>
        </a>
        <p class="mt-2 text-sm text-gray-500">
          Cheap and Fast Server Hosting<br>
          *Displayed prices do not include fees added by PayPal and Stripe
        </p>
      </div>
      <div
        class="
          flex-grow flex flex-wrap
          md:pl-20
          -mb-10
          md:mt-0
          mt-10
          md:text-left
          text-center
        "
      >
        <div class="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2
            class="
              title-font
              font-medium
              text-white
              tracking-widest
              text-sm
              mb-3
            "
          >
            Pages
          </h2>
          <nav class="list-none mb-10">
            <li>
              <a href="minecraft" class="text-gray-600 hover:text-gray-800"
                >Minecraft</a
              >
            </li>
            <li>
              <a href="factorio" class="text-gray-600 hover:text-gray-800"
                >Factorio</a
              >
            </li>
            <li>
              <a href="valheim" class="text-gray-600 hover:text-gray-800"
                >Valheim</a
              >
            </li>
            <li>
              <a href="discord" class="text-gray-600 hover:text-gray-800"
                >Discord</a
              >
            </li>
            <li>
              <a href="climate.html" class="text-gray-600 hover:text-gray-800"
                >Climate</a
              >
            </li>
          </nav>
        </div>

        <div class="lg:w-1/4 md:w-1/2 w-full px-4">
            <h2
              class="
                title-font
                font-medium
                text-white
                tracking-widest
                text-sm
                mb-3
              "
            >
              Sites
            </h2>
            <nav class="list-none mb-10">
              <li>
                <a href="https://fyrehost.net" class="text-gray-600 hover:text-gray-800"
                  >Home</a
                >
              </li>
              <li>
                <a href="https://panel.fyrehost.net" class="text-gray-600 hover:text-gray-800"
                  >Panel</a
                >
              </li>
              <li>
                <a href="https://docs.fyrehost.net" class="text-gray-600 hover:text-gray-800"
                  >Docs</a
                >
              </li>
              <li>
                <a href="mailto:support@fyrehost.net" class="text-gray-600 hover:text-gray-800"
                  >Support</a
                >
              </li>
              <li>
                <a href="https://fyrehost.net/tos.html" class="text-gray-600 hover:text-gray-800"
                  >Terms of Service</a
                >
              </li>
            </nav>
          </div>
      </div>
    </div>
    <div>
      <div
        class="
          container
          mx-auto
          py-4
          px-5
          flex flex-wrap flex-col
          sm:flex-row
        "
      >
        <p class="text-gray-500 text-sm text-center sm:text-left">
          © 2021 Copyright:
          <a
            href="https://fyrehost.net/"
            class="text-white ml-1"
            target="_blank"
            >FyreHost</a
          >
        </p>
        <span
          class="
            inline-flex
            sm:ml-auto sm:mt-0
            mt-2
            justify-center
            sm:justify-start
          "
        >
          <a href="" class="ml-3 text-white">
            <i class="fab fa-twitter"></i>
          </a>
        </span>
      </div>
    </div>
  </footer>